import { render, staticRenderFns } from "./PaginaNaoEncontrada.vue?vue&type=template&id=609b790c&scoped=true"
import script from "./PaginaNaoEncontrada.vue?vue&type=script&lang=js"
export * from "./PaginaNaoEncontrada.vue?vue&type=script&lang=js"
import style0 from "./PaginaNaoEncontrada.vue?vue&type=style&index=0&id=609b790c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609b790c",
  null
  
)

export default component.exports